<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="button_wrap">
      <el-button type="info" class="btn" @click="preview">{{
        language("shopInformation.preview")
      }}</el-button>
      <el-button type="primary" class="btn" @click="save">{{
        language("shopInformation.save")
      }}</el-button>
    </div>
    <div class="shop_info form" v-loading="loading">
      <el-tabs v-model="activeName">
        <template
          v-if="$menuList['SIS-ShopDisplay-View/Edit Info.-Shop Info.']"
        >
          <el-tab-pane
            :label="language('shopInformation.tab1')"
            name="tab1"
          ></el-tab-pane>
        </template>
        <template v-if="$menuList['SIS-ShopDisplay-View/EditInfo.-ShopDesc']">
          <el-tab-pane
            :label="language('shopInformation.tab2')"
            name="tab2"
          ></el-tab-pane>
        </template>
        <template
          v-if="$menuList['SIS-ShopDisplay-View/EditInfo.-CustomerServices']"
        >
          <el-tab-pane
            :label="language('shopInformation.tab3')"
            name="tab3"
          ></el-tab-pane>
        </template>
        <template v-if="$menuList['SIS-ShopDisplay-View/EditInfo.-T&C']">
          <el-tab-pane
            :label="language('shopInformation.tab4')"
            name="tab4"
          ></el-tab-pane>
        </template>
        <el-tab-pane
          :label="language('shopInformation.tab5')"
          name="tab5"
        ></el-tab-pane>
      </el-tabs>

      <template v-if="!loading">
        <div v-show="activeName == 'tab1'">
          <el-form
            ref="form1"
            :rules="rules"
            :model="form1"
            label-width="220px"
            label-position="left"
          >
            <tab1 v-model="form1" :formData="form1"></tab1>
          </el-form>
        </div>
        <div v-show="activeName == 'tab2'">
          <el-form
            ref="form2"
            :model="form2"
            label-width="250px"
            label-position="left"
          >
            <tab2 v-model="form2" :formData="form2"></tab2>
          </el-form>
        </div>

        <div v-show="activeName == 'tab3'">
          <el-form
            ref="form3"
            :model="form3"
            label-width="250px"
            label-position="left"
          >
            <tab3 v-model="form3" :formData="form3"></tab3>
          </el-form>
        </div>

        <div v-show="activeName == 'tab4'">
          <el-form
            ref="form4"
            :model="form4"
            label-width="250px"
            label-position="left"
          >
            <tab4 v-model="form4" :formData="form4"></tab4>
          </el-form>
        </div>

        <div v-show="activeName == 'tab5'">
          <el-form
            ref="form5"
            :model="form5"
            label-width="260px"
            label-position="left"
            :rules="rules"
          >
            <tab5 v-model="form5" :formData="form5"></tab5>
          </el-form>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import tab1 from "./components/tab/tab1";
import tab2 from "./components/tab/tab2";
import tab3 from "./components/tab/tab3";
import tab4 from "./components/tab/tab4";
import tab5 from "./components/tab/tab5";
export default {
  components: {
    breadcrumb,
    tab1,
    tab2,
    tab3,
    tab4,
    tab5,
  },
  data() {
    return {
      breadcrumb: {
        title: this.language("shopInformation.breadcrumbTitle"),
        list: [
          {
            name: this.language("shopInformation.breadcrumbList_1"),
          },
          {
            name: this.language("shopInformation.breadcrumbList_2"),
          },
        ],
      },
      activeName: "tab1",
      loading: true,
      // oldForm: {},
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      form5: {},
      rules: {
        aliasName: [
          // { required: true, message: "商店別名為空", trigger: "blur" },
          {
            //  required: true, message: "商店別名為空", trigger: "blur"
            validator: this.aliasName,
            trigger: "blur",
            required: true,
            message: this.language("shopList.shopAliasEmpty"),
          },
        ],
        nameChi: [
          {
            required: true,
            message: this.language("shopList.shopNameEmpty"),
            trigger: "blur",
          },
        ],
        nameEng: [
          {
            required: true,
            message: this.language("shopList.shopNameEmpty"),
            trigger: "blur",
          },
        ],
        categoryIds: [
          {
            required: true,
            message: this.language("shopList.categoryEmpty"),
            trigger: "blur",
          },
        ],
        logo: [{ required: true, message: "Logo為空", trigger: "blur" }],
        colorTheme: [
          {
            required: true,
            message: this.language("shopList.colorThemeEmpty"),
            trigger: "blur",
          },
        ],
        topBannerImg: [
          {
            required: true,
            message: this.language("shopList.topBananerEmpty"),
            trigger: "blur",
          },
        ],
        mchShopBizTimes: [
          {
            validator: this.mchShopBizTimes,
            trigger: "blur",
            required: true,
          },
        ],
        mchShopBizTimes2: [
          {
            validator: this.mchShopBizTimes2,
            trigger: "blur",
            required: true,
          },
        ],
        mchShopBizTimes3: [
          {
            validator: this.mchShopBizTimes3,
            trigger: "blur",
            required: true,
          },
        ],
      },
      score: "",
      group: {},
      shopData: {},
      openAutoPreview: false,
      autoPreviewTime: null,
    };
  },
  watch: {
    form5: {
      handler() {
        if (
          this.form5.mchShopBizTimes &&
          this.form5.mchShopBizTimes.length > 0
        ) {
          this.form5.mchShopBizTimes2 = [...this.form5.mchShopBizTimes];
          this.form5.mchShopBizTimes3 = [...this.form5.mchShopBizTimes];
        }
        if (this.openAutoPreview) {
          console.log(new Date().getTime());
          this.autoPreview();
        }
      },
      deep: true,
      immediate: true,
    },
    form1: {
      handler() {
        if (this.openAutoPreview) {
          console.log(new Date().getTime());
          this.autoPreview();
        }
      },
      deep: true,
      immediate: true,
    },
    form2: {
      handler() {
        if (this.openAutoPreview) {
          console.log(new Date().getTime());
          this.autoPreview();
        }
      },
      deep: true,
      immediate: true,
    },
    form3: {
      handler() {
        if (this.openAutoPreview) {
          console.log(new Date().getTime());
          this.autoPreview();
        }
      },
      deep: true,
      immediate: true,
    },
    form4: {
      handler() {
        if (this.openAutoPreview) {
          console.log(new Date().getTime());
          this.autoPreview();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    aliasName(rule, value, callback) {
      if (value == undefined || value == "") {
        callback(new Error(this.language("shopList.shopAliasMustNotEmpty")));
      } else {
        // var reg = /^[u4E00-u9FA5]+$/;
        // if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
        //   callback(new Error("商店別名不能含有中文"));
        // }
        var r = /^[A-Za-z0-9_]*$/;
        if (!r.test(value)) {
          callback(new Error(this.language("shopList.shopNameTips")));
        }
        callback();
      }
    },
    mchShopBizTimes(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[0].week.length; i++) {
        if (value[0].week[i].day > 0) {
          //普通時間
          if (
            value[0].week[i].isOnBussiness &&
            value[0].week[i].time &&
            value[0].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[0].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }
      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },

    mchShopBizTimes2(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[1].week.length; i++) {
        if (value[1].week[i].day > 0) {
          //普通時間
          if (
            value[1].week[i].isOnBussiness &&
            value[1].week[i].time &&
            value[1].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[1].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }

      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },

    mchShopBizTimes3(rule, value, callback) {
      let num = 0;
      for (let i = 0; i < value[2].week.length; i++) {
        if (value[2].week[i].day > 0) {
          //普通時間
          if (
            value[2].week[i].isOnBussiness &&
            value[2].week[i].time &&
            value[2].week[i].time.length > 0
          ) {
            num += 1;
          }
        } else {
          //節假日
          // if (value[2].week[i].isOnBussiness) {
          //   num += 1;
          // }
        }
      }

      if (num == 0) {
        callback(new Error(this.language("shopList.businessChooseTips")));
      } else {
        callback();
      }
    },
    getShopData(shopData) {
      this.loading = true;

      this.ccRequest
        .do("admin/merchant/shop/get", { id: shopData.id }, "GET")
        .then((e) => {
          this.score = e.score;
          this.mchGroup = e.mchGroup;
          this.loading = false;
          // this.oldForm = { ...e };
          this.form1 = { ...e };
          this.form2 = { ...e };
          this.form3 = { ...e };
          this.form4 = { ...e };
          this.form5 = { ...e };
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err.response.data.message);
        });
    },
    chekeForm(name) {
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    saveForm() {
      let langList = [];
      let form = {};
      if (this.form1.langList) {
        langList = [...langList, ...this.form1.langList];
        // delete this.form1.langList;
      }
      if (this.form2.langList) {
        langList = [...langList, ...this.form2.langList];
        // delete this.form2.langList;
      }
      if (this.form3.langList) {
        langList = [...langList, ...this.form3.langList];
        // delete this.form3.langList;
      }
      if (this.form4.langList) {
        langList = [...langList, ...this.form4.langList];
        // delete this.form4.langList;
      }
      if (this.form5.langList) {
        langList = [...langList, ...this.form5.langList];
        // delete this.form5.langList;
      }
      let mchShopBizTimes = [
        ...this.form5.mchShopBizTimes[0].week,
        ...this.form5.mchShopBizTimes[1].week,
        ...this.form5.mchShopBizTimes[2].week,
      ];
      for (let i = 0; i < mchShopBizTimes.length; i++) {
        if (mchShopBizTimes[i].isOnBussiness) {
          if (mchShopBizTimes[i].day > 0) {
            if (mchShopBizTimes[i].closeTime || mchShopBizTimes[i].openTime) {
              mchShopBizTimes[i].isOnBussiness = 1;
            } else {
              mchShopBizTimes[i].isOnBussiness = 0;
            }
          } else {
            if (mchShopBizTimes[i].isOnBussiness) {
              mchShopBizTimes[i].isOnBussiness = 1;
            } else {
              mchShopBizTimes[i].isOnBussiness = 0;
            }
          }
        } else {
          mchShopBizTimes[i].isOnBussiness = 0;
        }
      }
      form = {
        ...this.form1,
        ...this.form2,
        ...this.form3,
        ...this.form4,
        mchShopBizTimes: [...mchShopBizTimes],
        merchantNum: this.shopData.merchantNum,
      };
      form.langList = langList;
      return form;
    },
    save() {
      let chekeForm = [this.chekeForm("form5")];
      if (this.$menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."]) {
        chekeForm.push(this.chekeForm("form1"));
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-ShopDesc"]) {
        chekeForm.push(this.chekeForm("form2"));
      } else if (
        this.$menuList["SIS-ShopDisplay-View/EditInfo.-CustomerServices"]
      ) {
        chekeForm.push(this.chekeForm("form3"));
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-T&C"]) {
        chekeForm.push(this.chekeForm("form4"));
      }
      let result = Promise.all(chekeForm);

      result
        .then((data) => {
          let form = { ...this.saveForm() };
          this.ccRequest
            // .do("admin/merchant/shop/save", form, "POSTJSON")
            .do("admin/merchant/shop/updateInfo", form, "POSTJSON")
            .then((res) => {
              this.getShopData(this.shopData);
              this.$alert("待「一本」批核", "提示", {
                confirmButtonText: "確認",
                callback: (action) => {
                  this.$message({
                    message: this.language("shopInformation.success"),
                    type: "success",
                  });
                },
              });
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.mustNotEmpty"));
        });
    },
    setActiveName() {
      if (this.$menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."]) {
        this.activeName = "tab1";
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-ShopDesc"]) {
        this.activeName = "tab2";
      } else if (
        this.$menuList["SIS-ShopDisplay-View/EditInfo.-CustomerServices"]
      ) {
        this.activeName = "tab3";
      } else if (this.$menuList["SIS-ShopDisplay-View/EditInfo.-T&C"]) {
        this.activeName = "tab4";
      } else if (
        this.$menuList["SIS-ShopDisplay-View/Edit Info.-BussinessDays"]
      ) {
        this.activeName = "tab5";
      }
    },
    preview() {
      let chekeForm = [];
      if (this.$menuList["SIS-ShopDisplay-View/Edit Info.-Shop Info."]) {
        chekeForm.push(this.chekeForm("form1"));
      }
      let result = Promise.all(chekeForm);
      result
        .then((data) => {
          let form = { ...this.saveForm() };
          form.score = this.score;
          form.mchGroup = this.mchGroup;
          console.log(form);
          this.openAutoPreview = true;
          this.ccRequest
            .do(
              "admin/merchant/shop/preview/previewBeforeSaveChange",
              form,
              "POSTJSON"
            )
            .then((res) => {
              window.open(res);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(this.language("common.mustNotEmpty"));
        });
    },
    autoPreview() {
      window.clearInterval(this.autoPreviewTime);
      this.autoPreviewTime = setTimeout(() => {
        let form = { ...this.saveForm() };
        form.score = this.score;
        form.mchGroup = this.mchGroup;
        this.ccRequest
          .do(
            "admin/merchant/shop/preview/previewBeforeSaveChange",
            form,
            "POSTJSON"
          )
          .then((res) => {})
          .catch((err) => {
            this.$message.error(err.response.data.message);
          });
      }, 2000);
    },
  },
  mounted() {
    this.setActiveName();
    let shopData = this.storage.getStorage("shop");
    this.shopData = shopData;
    this.getShopData(shopData);
  },
};
</script>
<style></style>
<style scoped lang="scss">
.button_wrap {
  width: 300px;
  position: absolute;
  top: 40px;
  right: 100px;
  .btn {
    width: 45%;
  }
}
.shop_info {
  min-height: 100vh;
}
</style>
